import { Injectable, inject } from '@angular/core';

import { DEFAULT_SITE_DESCRIPTION, DEFAULT_SITE_KEYWORDS, DEFAULT_SITE_TITLE, SeoData, SITE_LOGO, SITE_NAME, TwitterCardType } from '@app/types/seo.types';
import { DomService } from '@app/common/services/dom.service';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private domService = inject(DomService);

  setSeoData(seoData: SeoData): void {
    const title = seoData.title ? `${seoData.title} | ${SITE_NAME}` : DEFAULT_SITE_TITLE;

    this.domService.updateTitle(title);

    this.domService.updateMetaNameTag('description', seoData.description ?? DEFAULT_SITE_DESCRIPTION);
    this.domService.updateMetaNameTag('keywords', seoData.keywords ?? DEFAULT_SITE_KEYWORDS);

    // Other SEO logic...
    this.domService.updateMetaPropertyTag('og:locale', 'pl_PL');
    this.domService.updateMetaPropertyTag('og:site_name', SITE_NAME);
    this.domService.updateMetaPropertyTag('og:title', title);
    this.domService.updateMetaPropertyTag('og:description', seoData.description);

    this.domService.updateMetaPropertyTag('og:image', seoData.ogImage?.url ?? SITE_LOGO);
    this.domService.updateMetaPropertyTag('og:image:width', '1200');
    this.domService.updateMetaPropertyTag('og:image:height', '630');
    this.domService.updateMetaPropertyTag('og:image:type', 'image/jpeg');
    this.domService.updateMetaPropertyTag('og:image:alt', seoData.ogImage?.alt);
    this.domService.updateMetaPropertyTag('og:url', seoData.ogUrl);
    this.domService.updateMetaPropertyTag('og:type', seoData.ogType);

    // The Twitter @username the card should be attributed to.
    // this.updateMetaTag('twitter:site', '@ssrmart');
    this.domService.updateMetaPropertyTag('twitter:card', seoData.twitterCardType ?? TwitterCardType.SummaryLargeImage);
    this.domService.updateMetaPropertyTag('twitter:title', title);
    this.domService.updateMetaPropertyTag('twitter:description', seoData.description);

    this.domService.updateMetaPropertyTag('twitter:image', seoData.ogImage?.url ?? SITE_LOGO);
    this.domService.updateMetaPropertyTag('twitter:image:alt', seoData.ogImage?.alt);

    this.domService.updateMetaPropertyTag('twitter:label1', seoData.twitterLabel?.key);
    this.domService.updateMetaPropertyTag('twitter:data1', seoData.twitterLabel?.value);
    this.domService.updateMetaPropertyTag('twitter:label2', seoData.twitterLabel2?.key);
    this.domService.updateMetaPropertyTag('twitter:data2', seoData.twitterLabel2?.value);
  }
}
